"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSplashScreenFormBodyText = exports.StyledSplashScreenFormBodyContent = exports.StyledSplashScreenFormBodyTitle = exports.StyledSplashScreenFormBodyIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../../helpers");
const Icon_1 = require("../../../../Icon");
const Text_1 = require("../../../../Text");
const View_1 = require("../../../../View");
exports.StyledSplashScreenFormBodyIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    color: ${({ theme }) => theme.colorLoginTitle};
`;
exports.StyledSplashScreenFormBodyTitle = (0, styled_components_1.default)(Text_1.Text) `
    font-size: 28px;
    line-height: 38px;
    color: ${({ theme }) => theme.colorLoginTitle};
`;
exports.StyledSplashScreenFormBodyContent = (0, styled_components_1.default)(View_1.View) `
    background-color: #fff;
    border-radius: ${helpers_1.SIZE_M};
    padding: ${helpers_1.SIZE_L};
`;
exports.StyledSplashScreenFormBodyText = (0, styled_components_1.default)(Text_1.Text) `
    line-height: ${helpers_1.SIZE_XL};
    color: ${({ theme }) => theme.colorLoginTitle};
`;
//# sourceMappingURL=SplashScreenFormBody.styles.js.map